module.exports = __webpack_public_path__ + "img/img.00ece82c.jpg";